import { AuthRoute, FlexRoutes } from 'src/routes'
import { Route } from 'react-router-dom'
import React from 'react'
import MarketsTabs from './markets-tabs'
import LocationConfigPage from 'src/companies/trade/location/location-config-page'
import SalesSeriesConfigPage from 'src/companies/trade/sales-series/sales-series-config-page'
import PlatformLocationConfigPage from './platform-location-config-page'

export default function MarketsIndex() {
  return (
    <FlexRoutes>
      <Route path="locations/:id" element={<AuthRoute as={LocationConfigPage} />} />
      <Route
        path="platform-locations/:id"
        element={<AuthRoute as={PlatformLocationConfigPage} />}
      />
      <Route path="sales-series/:id" element={<AuthRoute as={SalesSeriesConfigPage} />} />
      <Route path="sales-series/new" element={<AuthRoute as={SalesSeriesConfigPage} />} />
      <Route path="*" element={<AuthRoute as={MarketsTabs} />} />
    </FlexRoutes>
  )
}
